// Words and time helpers of «دستیار برنامه‌ریزی کار» (docs/tasks/35-schedule-assistant-progress-chart.md).
// Times arrive as ISO strings; the page works in unix seconds (as the task form and the date picker do).

export const DURATIONS = [30, 60, 90, 120];
const TEHRAN_OFFSET_MINUTES = 210;
const DAY_MS = 24 * 60 * 60 * 1000;

export const digits = (value) => new Intl.NumberFormat("fa-IR").format(value);
export const toSeconds = (iso) => Math.floor(Date.parse(iso) / 1000);

export function tehranDayOf(seconds) {
    return new Date(seconds * 1000 + TEHRAN_OFFSET_MINUTES * 60000).toISOString().slice(0, 10);
}

export function addDays(day, days) {
    return new Date(Date.parse(`${day}T00:00:00Z`) + days * DAY_MS).toISOString().slice(0, 10);
}

// «۱۰:۳۰» in Tehran
export function clock(value) {
    const ms = typeof value === "number" ? value * 1000 : Date.parse(value);
    try {
        return new Intl.DateTimeFormat("fa-IR", {hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Tehran"}).format(new Date(ms));
    } catch {
        return "";
    }
}

// «دوشنبه ۴ آبان»
export function dayLabel(day) {
    try {
        return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {weekday: "long", day: "numeric", month: "long", timeZone: "Asia/Tehran"}).format(new Date(`${day}T12:00:00Z`));
    } catch {
        return day;
    }
}

// «امروز» / «فردا» / «دوشنبه ۴ آبان»
export function relativeDay(day, today) {
    if (day === today) return "امروز";
    if (day === addDays(today, 1)) return "فردا";
    return dayLabel(day);
}

export function minutesText(minutes) {
    if (!minutes) return "";
    if (minutes < 60) return `${digits(minutes)} دقیقه`;
    const hours = minutes / 60;
    return Number.isInteger(hours) ? `${digits(hours)} ساعت` : `${digits(minutes)} دقیقه (${digits(Math.round(hours * 10) / 10)} ساعت)`;
}

// the position of a range on the day bar (search window), in percent of its width; null when outside
export function barSegment(startIso, endIso, day, window) {
    const [fromH, fromM] = window.from.split(":").map(Number);
    const [toH, toM] = window.to.split(":").map(Number);
    const base = Date.parse(`${day}T00:00:00Z`) - TEHRAN_OFFSET_MINUTES * 60000;
    const from = base + (fromH * 60 + fromM) * 60000;
    const to = base + (toH * 60 + toM) * 60000;
    const start = Math.max(Date.parse(startIso), from);
    const end = Math.min(Date.parse(endIso), to);
    if (end <= start) return null;
    return {left: ((start - from) / (to - from)) * 100, width: ((end - start) / (to - from)) * 100};
}
